/**
 * Persistent user settings. Mirrors the Android `UserSettings` class. The
 * values are stored in `localStorage` under namespaced keys.
 */

/** User-selectable theme. */
export type ThemeChoice = 'SYSTEM' | 'LIGHT' | 'DARK' | 'NEON';

/** Difficulty presets. Each level scales the engine speed + obstacle density. */
export enum Difficulty {
  RELAXED = 'RELAXED',
  NORMAL = 'NORMAL',
  FAST = 'FAST',
  INSANE = 'INSANE',
}

export const DIFFICULTY_PARAMS: Record<
  Difficulty,
  { baseScrollSpeed: number; scrollGrowth: number; spawnDensity: number }
> = {
  [Difficulty.RELAXED]: { baseScrollSpeed: 170, scrollGrowth: 18, spawnDensity: 1.3 },
  [Difficulty.NORMAL]: { baseScrollSpeed: 220, scrollGrowth: 26, spawnDensity: 1.0 },
  [Difficulty.FAST]: { baseScrollSpeed: 280, scrollGrowth: 32, spawnDensity: 0.78 },
  [Difficulty.INSANE]: { baseScrollSpeed: 340, scrollGrowth: 38, spawnDensity: 0.6 },
};

/** Visual glow intensity for the neon look. */
export enum GlowLevel {
  OFF = 'OFF',
  LOW = 'LOW',
  MEDIUM = 'MEDIUM',
  HIGH = 'HIGH',
}

/** Color blind friendly palette swaps red/green for blue/yellow. */
export type ColorBlindMode = 'OFF' | 'BLUE_YELLOW' | 'HIGH_CONTRAST';

export interface PersistedSettings {
  soundEnabled: boolean;
  highScore: number;
  longestRun: number;
  furthestLevel: number;
}

export const DEFAULT_SETTINGS: PersistedSettings = {
  soundEnabled: true,
  highScore: 0,
  longestRun: 0,
  furthestLevel: 1,
};
